// Component: BasicDetails.jsx
// Description: This component is utilized for creating and updating the basic details of the T&C
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import { Box, Typography, Grid, Paper, debounce, Button, Stack, DialogContent, IconButton, Dialog, DialogTitle } from "@mui/material";
// import { useNavigate } from "react-router";
import AssetFooter from "../commoncomponents/AssetFooter";
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import { setBasicDetailsFields, } from "../../redux/actions/TestingCommission/dispatchActions";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import utils from "../../utility/utilities";
import { getFacilityId } from "../../utility/tokenUtility";
import { fetchVendorDetails, fetchMastersDetails, fetchHospitalDetails, fetchWorkGroupDetails, getCriticalityOptions, fetchTypeCodeDetails, generateTCNumber, fetchlocationmasterDetails } from "../../components/testingcommission_components/testingCommissionAPIs";
import CustomAlert from '../userlocationcomponents/CustomAlert';
import dayjs from 'dayjs';
import { tcCreateUpdateRepository } from "../../api/repositories/TestingandCommissioning/tcCreateUpdateRepository";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import { validations } from "../../utility/constants/errors/messages";
import PageLoader from "../commoncomponents/PageLoader";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteTC, getTCListByID, getbemExportList, getbemTCList, getfemExportList, getfemTCList } from './testingCommissionAPIs';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

const BasicDetails = () => {

  //varibale declaration
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const facilityid = getFacilityId("facilityId");
  const currentDate = utils.getCurrentDateFormatted("DD-MM-YYYY");

  //get the common testing and comissioning details from redux  
  let tcDetails = useSelector(state => state?.TestingCommissionDetails?.tcDetails);
  let checkFields = tcDetails;
  tcDetails = (tcDetails?.id === '') ? location.state.tcDetails : tcDetails;
  //get basic details from redux
  let basicDetails = useSelector(state => state?.TestingCommissionDetails?.basicDetails);
  basicDetails = (basicDetails?.id === '') ? location.state.basicDetails : basicDetails;
  let otherDetails = useSelector((state) => state.TestingCommissionDetails.othersDetails);
  otherDetails = (checkFields?.id === '') ? location.state.TcOthers : otherDetails;

  //state declaration
  const [basicDetailsTC, setbasicDetailsTC] = useState(basicDetails || {});

  //state to check all maditory fields are filled
  const [isFilledAllMandatoryField, setIsFilledAllMandatoryField] = useState(false);

  // Initialize error state
  const [errors, setErrors] = useState({
    service: false,
    vendorname: false,
    typecode: false,
    location: false,
    istestpassed: false,
    testingcommissioncompletedate: false,
    assetdesc: false
  });
  // Initialize error messages for mandatory fields
  const [errorMessages, setErrorMessages] = useState({
    service: '',
    vendorname: '',
    typecode: '',
    location: '',
    testingcommissioncompletedate: '',
    assetdesc: ''
  });

  //state to hold the tc number
  const [tcNo, setTcNo] = useState('');

  //state to hold the dropdown options
  const [basicDetailsTCOptions, setbasicDetailsTCOptions] = useState({
    serviceOptions: [],
    workgroupOptions: [],
    workgroupOptionsFEMS: [],
    workgroupOptionsBEMS: [],
    typecodeOptions: [],
    typecodeOptionsFEM: [],
    typecodeOptionsBEM: [],
    locationOptions: [],
    vendorOptions: [],
    hospitalOptions: [],
    criticalityOptions: [],
    criticalityOptionsFEMS: [],
    criticalityOptionsBEMS: [],
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [failedDialogOpen, setFailedDialogOpen] = useState(false);
  const [failedDialogOpenForDocumentSerialNumberDuplicate,
    setFailedDialogOpenForDocumentSerialNumberDuplicate] = useState(false);
  const [isVendorLogin, setIsVendorLogin] = useState(localStorage.getItem("roleName") === "Vendors" ? true : false);
  const [initialBasicDetails, setInitialBasicDetails] = useState({});
  const [isDisableAllfileds, setIsDisableAllfileds] = useState(false);
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gridApi, setGridApi] = useState({});
  const [buttondisabled, setButtondisabled] = useState(false);
  // const statusId = (tcDetails?.statusid || "");
  const statusId = ((tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId) || tcDetails?.statusid);
  const statusArray = [
    { id: 1, value: 'open' },
    { id: 2, value: 'inprogress' },
    { id: 3, value: 'submitted' },
    { id: 4, value: 'completed' },
    { id: 5, value: 'authorized' },
    { id: 6, value: 'rejected' },
  ];
  const status = statusId ? statusArray?.find((item) => item?.id === statusId)?.value : '';
  // const [costInfoData, setCostInfoData] = useState(costInfo || {});
  // const purchaseprice = basicDetailsTC?.purchaseprice ?.costInfo || {};

  const setBasicDetailsInfoInEditMode = async (response, rowData) => {

    const { serviceid, serviceDesc, typecode, typecodeDesc, typecodeid, vendorid, vendorname, vendorcode, workgroupid, workgroup, wgdesc } = rowData;
    const serviceData = { id: serviceid, label: serviceDesc, value: serviceDesc };
    const typecodeData = { id: typecodeid, label: typecode, value: typecodeDesc, typecode: typecode };
    const vendorData = { id: vendorid, label: `${vendorname}`, value: vendorcode, vendorname: vendorname };
    const workgroupData = { id: workgroupid, label: `${workgroup} - ${wgdesc}`, value: workgroup };
    const criticality = [{ key: 'option-0', label: 'Normal', isvisible: true, id: 1 },
    { key: 'option-1', label: 'Critical', isvisible: true, id: 2 }]
    const criticalityObj = criticality?.find((item) => item?.label === response?.riskstatus)
    const basicDetailsTc = {
      criticality: response?.riskstatus ? criticalityObj : '',
      isDateSetInEditMode: false,
      isEditMode: true,
      id: response?.id,
      testingcommissionno: response?.testingcommissionno,
      status: '',
      // basicDetails mandatory fields
      service: serviceid ? serviceData : '',
      vendorname: vendorid ? vendorData : '',
      typecode: typecodeid ? typecodeData : '',
      workgroup: workgroupid ? workgroupData : '',
      assetdesc: response?.assetdesc || '',
      testingcommissionstartdate: dayjs().format('YYYY-MM-DDTHH:mm:ss') || '',
      //non mandatory fields
      location: '',
      model: response?.model || '',
      serialno: response?.serialno || '',
      chassisno: response?.chassisno || '',
      registerno: response?.registerno || '',
      purchaseprice: !isNaN(parseFloat(response?.purchaseprice)) ? parseFloat(response.purchaseprice).toFixed(2) : "0.00",

      purchaseorderno: response?.purchaseorderno || '',
      financeassetno: response?.financeassetno || '',
      manufacturer: response?.manufacturer || '',
      warrantystartdate: response?.warrantystartdate ? dayjs(response?.warrantystartdate).format('DD/MM/YYYY') : '',
      warrantyexpirydate: response?.warrantyexpirydate ? dayjs(response?.warrantyexpirydate).format('DD/MM/YYYY') : '',
      isunderwarranty: "",
      lifespan: response?.lifespan || '',
      istestpassed: response?.istestpassed !== undefined ?
        (response?.istestpassed === true ? { value: true, label: 'PASSED' } : { value: false, label: 'FAILED' }) :
        '',
      testingcommissioncompletedate: response?.testingcommissioncompletedate ? dayjs(response?.testingcommissioncompletedate).format('DD/MM/YYYY') : '',
      remarks: response?.remarks || '',
    };
    dispatch(setBasicDetailsFields(basicDetailsTc));
    return basicDetailsTc;

  }

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleLocationClick = (rowData) => {
    setbasicDetailsTC((prev) => ({
      ...prev,
      location: rowData
    }));

    handleCloseModal()
  };




  const columns = [
    {
      headerName: 'Location Code',
      field: 'Locationcode',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            // handleFieldChange(params.data);  // Call the handleAssetClick function with the clicked asset's data
            handleLocationClick(params?.data)
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Location Description', field: 'value', width: 200 },
    { headerName: 'Department Code', field: 'userdepartmentcode', width: 100 },
    { headerName: 'Department Description', field: 'userdepartment', width: 150 },

  ];



  const getMastersDetails = async () => {
    try {
      setIsLoading(true);
      const masterData = await fetchMastersDetails(facilityid);
      const getlocationdetails = await fetchlocationmasterDetails(facilityid);
      const vendorData = await fetchVendorDetails(facilityid);
      const workgroupDataFEMS = await fetchWorkGroupDetails('FEMS');
      const workgroupdataBEMS = await fetchWorkGroupDetails('BEMS');
      const hospitalData = await fetchHospitalDetails(facilityid);
      const criticalityDataFEMS = await getCriticalityOptions('FEMS');
      const criticalityDataBEMS = await getCriticalityOptions('BEMS');

      const serviceOptions = masterData.masservicedetails ? masterData.masservicedetails.map(item => ({
        value: item?.service,
        label: item?.service,
        id: item?.id
      })) : [];

      const femServiceID = serviceOptions.find(item => item.value === 'FEMS')?.id;
      const bemServiceID = serviceOptions.find(item => item.value === 'BEMS')?.id;

      const typecodeDataFEM = await fetchTypeCodeDetails(femServiceID);
      const typecodeDataBEM = await fetchTypeCodeDetails(bemServiceID);

      const typecodeOptionsFEM = typecodeDataFEM ? typecodeDataFEM.map(item => ({
        id: item?.id,
        value: item?.typedescription,
        label: `${item?.typecode} - ${item?.typedescription}`,
        typecode: item?.typecode
      })) : [];

      const typecodeOptionsBEM = typecodeDataBEM ? typecodeDataBEM.map(item => ({
        id: item?.id,
        value: item?.typedescription,
        label: `${item?.typecode} - ${item?.typedescription}`,
        typecode: item?.typecode
      })) : [];

      const locationOptions = getlocationdetails?.userLocationVMs ? getlocationdetails?.userLocationVMs.map(item => ({
        id: item?.id,
        label: `${item?.locationcode} - ${item?.locationdesc}`,
        value: item?.locationdesc, // assuming location has an id and name
        userdepartment: item?.departmentdesc,
        userdepartmentcode: item?.departmentcode,
        Locationcode: item?.locationcode
      })) : [];

      const hospitalOptions = hospitalData ? hospitalData.map(item => ({
        id: item?.id,
        label: item?.locationdesc,
        value: item?.locationcode // assuming location has an id and name
      })) : [];

      const vendorOptions = vendorData ? vendorData.map(item => ({
        id: item?.id,
        label: `${item?.vendorcode} - ${item?.vendorname}`,// assuming location has an id and name
        value: item?.vendorcode,
        vendorname: item?.vendorname
      })) : [];


      const workgroupOptionsFEMS = workgroupDataFEMS ? workgroupDataFEMS.map(item => ({
        id: item?.id,
        label: `${item?.wgcode} - ${item?.wgdesc}`,// assuming location has an id and name
        value: item?.wgcode
      })) : [];

      const workgroupdOptionsBEMS = workgroupdataBEMS ? workgroupdataBEMS.map(item => ({
        id: item?.id,
        label: `${item?.wgcode} - ${item?.wgdesc}`,// assuming location has an id and name
        value: item?.wgcode
      })) : [];

      const criticalityOptionsFEMS = criticalityDataFEMS?.map((item, index) => ({
        key: `option-${index}`,
        label: item?.riskstatus,
        isvisible: item?.isvisible,
        id: item?.id
      }));
      const criticalityOptionsBEMS = criticalityDataBEMS?.map((item, index) => ({
        key: `option-${index}`,
        label: item?.riskstatus,
        isvisible: item?.isvisible,
        id: item?.id
      }))
      const serviceType = basicDetailsTC?.service?.label;
      setbasicDetailsTCOptions(prevbasicDetailsTCOptions => ({
        ...prevbasicDetailsTCOptions,
        serviceOptions: serviceOptions,
        typecodeOptionsFEM: typecodeOptionsFEM,
        typecodeOptionsBEM: typecodeOptionsBEM,
        workgroupOptionsFEMS: workgroupOptionsFEMS,
        workgroupOptionsBEMS: workgroupdOptionsBEMS,
        locationOptions: locationOptions,
        vendorOptions: vendorOptions,
        hospitalOptions: hospitalOptions,
        criticalityOptionsFEMS: criticalityOptionsFEMS,
        criticalityOptionsBEMS: criticalityOptionsBEMS,
        criticalityOptions: serviceType === 'FEMS' ? criticalityOptionsFEMS : (serviceType === 'BEMS' ? criticalityOptionsBEMS : [])
      }));

      //set all the lookup and dropdown values if basicDetailsTC is in edit mode and already data is not set
      if (basicDetailsTC?.id && basicDetailsTC?.isEditMode && !basicDetailsTC?.isDateSetInEditMode) {
        const getByIDResponse = tcDetails;

        let getCriticalityById = { label: '', id: '' };
        let criticalityId;
        if (getByIDResponse?.riskstatus) {
          criticalityId = getByIDResponse?.riskstatus;
          getCriticalityById = criticalityOptionsFEMS?.find((item) => item?.label === criticalityId);
          setbasicDetailsTCOptions(prevbasicDetailsTCOptions => ({
            ...prevbasicDetailsTCOptions,
            criticalityOptions: criticalityOptionsFEMS
          }))
        }
        if (getByIDResponse?.riskstatus) {
          criticalityId = getByIDResponse?.riskstatus;
          getCriticalityById = criticalityOptionsBEMS?.find((item) => item?.label === criticalityId);
          setbasicDetailsTCOptions(prevbasicDetailsTCOptions => ({
            ...prevbasicDetailsTCOptions,
            criticalityOptions: criticalityOptionsBEMS
          }))
        }
        const userlocationid = getByIDResponse?.userlocationid;
        const getLocationById = locationOptions?.find((item) => item?.id === userlocationid);
        const vendorId = getByIDResponse?.vendorid;
        const getVendorById = vendorOptions?.find((item) => item?.id === vendorId);

        setbasicDetailsTC((prevbasicDetailsTC) => ({
          ...prevbasicDetailsTC,
          location: userlocationid ? getLocationById : "",
          vendorname: vendorId ? (getVendorById || { id: vendorId || "", label: getByIDResponse?.vendorname || "" }) : "",
          criticality: getCriticalityById,
          isDateSetInEditMode: true,
        }));

        setInitialBasicDetails({
          ...basicDetailsTC,
          location: userlocationid ? getLocationById : "",
          vendorname: vendorId ? getVendorById : "",
          criticality: getCriticalityById,
          isDateSetInEditMode: true,
        })

        const serviceType = basicDetailsTC?.service?.label;
        if (serviceType) {
          if (serviceType === 'FEMS') {
            setbasicDetailsTCOptions(prevbasicDetailsTCOptions => ({
              ...prevbasicDetailsTCOptions,
              workgroupOptions: workgroupOptionsFEMS,
              criticalityOptions: criticalityOptionsFEMS,
              typecodeOptions: typecodeOptionsFEM
            }));
          } else {
            setbasicDetailsTCOptions(prevbasicDetailsTCOptions => ({
              ...prevbasicDetailsTCOptions,
              workgroupOptions: workgroupdOptionsBEMS,
              criticalityOptions: criticalityOptionsBEMS,
              typecodeOptions: typecodeOptionsBEM
            }));
          }
        }
      }

    } catch (error) {
      console.log("Error fetching Masters details :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (tcDetails?.isViewMode) {
      setIsDisableAllfileds(true);
    }
    if (tcDetails?.isVendorLogin) {
      setIsVendorLogin(true);
      navigate(location.pathname, {
        state: {
          ...location.state,
          tcDetails: { ...location.state.tcDetails, ...tcDetails },

        }
      });
    }
    setInitialBasicDetails(basicDetailsTC);
    getMastersDetails();
  }, []);

  useEffect(() => {
    if (basicDetails?.warrantyexpirydate && basicDetails?.warrantystartdate) {
      checkIsUnderWarranty(basicDetails.warrantystartdate, basicDetails.warrantyexpirydate)
    }
  }, [basicDetails])

  // console.log(basicDetailsTC,"basicDetailsTC")
  const memoizedDetails = useMemo(() => ({
    service: basicDetailsTC?.service || '',
    vendorname: basicDetailsTC?.vendorname || '',
    typecode: basicDetailsTC?.typecode || '',
    workgroup: basicDetailsTC?.workgroup || '',
    assetdesc: basicDetailsTC?.assetdesc || '',
  }), [
    basicDetailsTC?.service,
    basicDetailsTC?.vendorname,
    basicDetailsTC?.typecode,
    basicDetailsTC?.workgroup,
    basicDetailsTC?.assetdesc,
  ]);

  const checkTextBoxValue = (value) => {
    const pattern = /^(?! )[a-zA-Z0-9,!@#$%&*()_-]+(?: [a-zA-Z0-9,!@#$%&*()_-]+)* ?$/
    if (pattern.test(value)) {
      return true;
    } else {
      return false
    }
  };

  //function to check the mandatory field are filled or not(responsible for green ticks on left side)
  const checkMandatoryValueFilled = useCallback(debounce((
    service,
    vendorname,
    typecode,
    workgroup,
    assetdesc,
  ) => {
    const updateStatus = (type, value, name, isMandatory) => ({
      type,
      valueFilled: !!value,
      name,
      isMandatory
    });

    const updateService = updateStatus("Service Type", service, 'service', true);
    const updatevendorname = updateStatus("Vendor Name", vendorname, 'vendorname', true);
    const updatetypecode = updateStatus("Type Code", typecode, 'typecode', true);
    const updateworkgroup = updateStatus("Work Group", workgroup, 'workgroup', true);
    const updateassetdesc = updateStatus("Asset Description", checkTextBoxValue(assetdesc), 'assetdesc', true);

    let arrayAfterUpdating = [
      updateService,
      updatevendorname,
      updatetypecode,
      updateworkgroup,
      updateassetdesc
    ];

    if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
      dispatch({ type: TCActionsTypes.SET_BASIC_DETAILS_MANDATORY_FIELDS, payload: arrayAfterUpdating });
    }
  }), [dispatch]);

  useEffect(() => {
    const {
      service,
      vendorname,
      typecode,
      workgroup,
      assetdesc,
    } = memoizedDetails;



    checkMandatoryValueFilled(service?.id, vendorname?.id, typecode?.id, workgroup?.id, assetdesc);
  }, [memoizedDetails, checkMandatoryValueFilled]);

  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);

  // const checkIsUnderWarranty = (startDate, endDate) => {
  //   const today = dayjs();
  //   const start = dayjs(startDate, 'DD-MM-YYYY'); // Ensure correct format
  //   const end = dayjs(endDate, 'DD-MM-YYYY');    // Ensure correct format

  //   if (start.isValid() && end.isValid()) {
  //     if (today.isAfter(start) && today.isBefore(end)) {
  //       setbasicDetailsTC((prev) => ({
  //         ...prev,
  //         isunderwarranty: true
  //       }));
  //     } else {
  //       setbasicDetailsTC((prev) => ({
  //         ...prev,
  //         isunderwarranty: false
  //       }));
  //     }
  //   } else {
  //     setbasicDetailsTC((prev) => ({
  //       ...prev,
  //       isunderwarranty: false
  //     }));
  //   }
  // };

  //Back Page 
  const checkIsUnderWarranty = (startDate, endDate) => {
    const today = dayjs().startOf('day'); // Ensure comparison is consistent
    const start = dayjs(startDate, 'DD-MM-YYYY').startOf('day'); // Ensure correct format and time
    const end = dayjs(endDate, 'DD-MM-YYYY').startOf('day'); // Ensure correct format and time

    if (start.isValid() && end.isValid()) {
      // Check if today is within or on the start/end dates
      if (today.isSameOrAfter(start) && today.isSameOrBefore(end)) {
        setbasicDetailsTC((prev) => ({
          ...prev,
          isunderwarranty: true,
        }));
      } else {
        setbasicDetailsTC((prev) => ({
          ...prev,
          isunderwarranty: false,
        }));
      }
    } else {
      // If dates are invalid, set under warranty to false
      setbasicDetailsTC((prev) => ({
        ...prev,
        isunderwarranty: false,
      }));
    }
  };

  const handleFieldChange = (value, field, isMandatoryField) => {
    // Check if the field requires a 'label' property
    if (field === 'typecode') {
      if (value?.id) {
        setIsDataChanged(true);
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { ...value, label: value?.typecode ? value?.typecode : '' }
        }));
      } else {
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { id: '', label: '', value: '' }
        }));
      }
    } else if (field === 'vendorname') {
      if (value?.id) {
        setIsDataChanged(true);
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { ...value, label: value?.vendorname ? value?.vendorname : '' }
        }));

      } else {
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { id: '', label: '', value: '' }
        }));
      }
    } else if (field === 'location') {
      if (value?.id) {
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { label: value?.value ? value?.value : '', id: value.id ? value.id : '', value: value.value ? value.value : '', userdepartment: value?.userdepartment ? value.userdepartment : '' }
        }));
        setIsDataChanged(true);
      } else {
        setbasicDetailsTC(prevbasicDetailsTC => ({
          ...prevbasicDetailsTC,
          [field]: { id: '', label: '', value: '' }
        }));
      }
    } else {
      setIsDataChanged(true);
      // For fields that do not require a 'label' property
      setbasicDetailsTC(prevbasicDetailsTC => ({
        ...prevbasicDetailsTC,
        [field]: value
      }));
    }

    // Update Redux state for basic details fields
    // dispatch(setBasicDetailsFields({ [field]: value }));
    navigate(location.pathname, {
      state: {
        ...location.state,
        basicDetails: { ...location.state.basicDetails, [field]: value },

      }
    });

    setErrors(prevErrors => ({
      ...prevErrors,
      [field]: false  // Set error status to false for the field
    }));

    // Clear error message locally if needed
    setErrorMessages(prevErrorMessages => ({
      ...prevErrorMessages,
      [field]: ''  // Clear error message for the field
    }));

    const checkwarrantystartdate = field === 'warrantystartdate' ? value : basicDetailsTC?.warrantystartdate;
    const checkWarrentyEndDate = field === 'warrantyexpirydate' ? value : basicDetailsTC?.warrantyexpirydate;

    if (field === 'warrantyexpirydate' || field === 'warrantystartdate') {
      checkIsUnderWarranty(checkwarrantystartdate, checkWarrentyEndDate);
    }

    if (field === 'service') {
      if (value?.id) {
        setbasicDetailsTC((prevbasicDetailsTC) => ({
          ...prevbasicDetailsTC,
          workgroup: '',
          criticality: '',
          typecode: '',
        }));
        if (value?.label === 'FEMS') {
          setbasicDetailsTCOptions((prevbasicDetailsTCOptions) => ({
            ...prevbasicDetailsTCOptions,
            workgroupOptions: prevbasicDetailsTCOptions?.workgroupOptionsFEMS,
            criticalityOptions: prevbasicDetailsTCOptions?.criticalityOptionsFEMS,
            typecodeOptions: prevbasicDetailsTCOptions?.typecodeOptionsFEM,
          }))
        } else if (value?.label === 'BEMS') {
          setbasicDetailsTCOptions((prevbasicDetailsTCOptions) => ({
            ...prevbasicDetailsTCOptions,
            workgroupOptions: prevbasicDetailsTCOptions?.workgroupOptionsBEMS,
            criticalityOptions: prevbasicDetailsTCOptions?.criticalityOptionsBEMS,
            typecodeOptions: prevbasicDetailsTCOptions?.typecodeOptionsBEM,
          }))
        }
      } else {
        setbasicDetailsTC((prevbasicDetailsTC) => ({
          ...prevbasicDetailsTC,
          workgroup: '',
          criticality: '',
          typecode: '',
        }));
        setbasicDetailsTCOptions((prevbasicDetailsTCOptions) => ({
          ...prevbasicDetailsTCOptions,
          workgroupOptions: [],
          criticalityOptions: [],
          typecodeOptions: [],
        }))
      }
    }

    if (isMandatoryField) {
      //make the error flag to false once user enters value
      setErrors((prev) => {
        const updatedError = {
          ...prev,
          [field]: false
        };

        const isAllFalse = Object.values(updatedError).every((value) => value === false);

        if (isAllFalse) {
          setIsFilledAllMandatoryField(false);
        }

        return updatedError;
      });
      //clear the error message once the user enters value
      setErrorMessages((prev) => (
        {
          ...prev,
          [field]: ''
        }
      ));
    }

    if (field === 'assetdesc') {
      if (value) {
        setErrors((prev) => ({ ...prev, assetdesc: false }));
        setErrorMessages((prev) => ({ ...prev, assetdesc: "" }));
      }
      if (!value || utils.validateTextField(value)) {
        setErrors((prev) => ({ ...prev, assetdesc: false }));
        setErrorMessages((prev) => ({ ...prev, assetdesc: "" }));
      } else if (!utils.validateTextField(value)) {
        setErrors((prev) => ({ ...prev, assetdesc: true }));
        setErrorMessages((prev) => ({ ...prev, assetdesc: validations.textfield, }));
      }
    }
  };


  const validateForm = () => {
    let formIsValid = true;
    const errorStatus = { ...errors };
    const newErrorMessages = { ...errorMessages };

    if (!basicDetailsTC?.service) {
      formIsValid = false;
      errorStatus.service = true;
      newErrorMessages.service = 'Service is required';
    }

    if (!basicDetailsTC.vendorname?.label) {
      formIsValid = false;
      errorStatus.vendorname = true;
      newErrorMessages.vendorname = 'Vendor Name is required';
    }
    if (!basicDetailsTC.typecode?.label) {
      formIsValid = false;
      errorStatus.typecode = true;
      newErrorMessages.typecode = 'Type Code is required';
    }
    if (!basicDetailsTC.assetdesc) {
      formIsValid = false;
      errorStatus.assetdesc = true;
      newErrorMessages.assetdesc = 'Asset Description is required';
    }
    if (!basicDetailsTC.workgroup) {
      formIsValid = false;
      errorStatus.workgroup = true;
      newErrorMessages.workgroup = 'Work Group is required';
    }
    setErrors(errorStatus);
    setErrorMessages(newErrorMessages);
    return formIsValid;
  };

  const getTrueKeys = (obj) => {
    return obj ? Object?.keys(obj)?.filter(key => obj[key])?.join(',') : '';
  };

  const getUpdateFormattedOtherDetails = (othersDetails) => {
    return {
      class: getTrueKeys(othersDetails?.class),
      powercord: getTrueKeys(othersDetails?.powerCard),
      isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
      referenceno: getTrueKeys(othersDetails?.referenceNo),
      type: getTrueKeys(othersDetails?.type),
    };
  };

  const checkStatus = (status, oldDetails, newDetails) => {
    if (basicDetailsTC?.isEditMode) {
      const id = tcDetails?.femtestingcommissionstatusId || tcDetails?.bemtestingcommissionstatusId;
      const statuses = {
        3: { Testcommissionstatus: 'Submitted', id: 3 },
        5: { Testcommissionstatus: 'Authorized', id: 5 },
        6: { Testcommissionstatus: 'Rejected', id: 6 }
      };

      // Check if any data has changed
      const hasDataChanged = Object.keys(oldDetails).some(key => oldDetails[key] !== newDetails[key]);
      if (hasDataChanged) {
        return status;
      } else {
        return statuses[id] || status;
      }
    }

    return status;
  };

  const handleCreateUpdate = async (isEditMode, testingCommissionId, status) => {
    try {
      setButtondisabled(true);
      const serviceType = basicDetailsTC?.service?.label;
      const processingpercentage = tcDetails?.processingpercentage;
      let response;
      const updatedOtherDetails = getUpdateFormattedOtherDetails(otherDetails);
      const formData = { ...basicDetailsTC, ...updatedOtherDetails, processingpercentage }
      if (isEditMode && testingCommissionId) {
        setButtondisabled(true);
        const isStatusAthorizedorRejected = checkStatus(status, initialBasicDetails, basicDetailsTC);
        response = await tcCreateUpdateRepository.updateTC(formData, testingCommissionId, serviceType, isStatusAthorizedorRejected);
        const updatedState = {
          ...location.state, // Keep existing state
          tcDetails: { ...location.state.tcDetails, ...response }, // Add or update keys
          isEditMode: true
        };

        navigate(location.pathname, { state: updatedState });
        dispatch({ type: TCActionsTypes.SET_TC_FIELD_VALUES, payload: response });
        setButtondisabled(false);
      } else {
          setButtondisabled(true);
        const tcNo = await generateTCNumber('T&c');
        if (tcNo) {
        
          setTcNo(tcNo);
          setBasicDetailsFields({ ...basicDetailsTC, testingcommissionno: tcNo });
          const basicDetails = { ...basicDetailsTC, testingcommissionno: tcNo };
          const updatedState = {
            ...location.state, // Keep existing state
            basicDetails: { ...location.state.basicDetails, ...basicDetailsTC, testingcommissionno: tcNo }, // Add or update keys
          };
          navigate(location.pathname, { state: updatedState });
          dispatch(setBasicDetailsFields(basicDetails));
          response = await tcCreateUpdateRepository.createTC({ ...basicDetailsTC, testingcommissionno: tcNo, processingpercentage: 35 }, status, serviceType);
          
          if (response?.id) {
            setSuccessDialogOpen(true);
            setButtondisabled(false);
            const updatedState = {
              ...location.state, // Keep existing state
              tcDetails: { ...location.state.tcDetails, ...basicDetailsTC, testingcommissionno: tcNo, ...response }, // Add or update keys
            };
            navigate(location.pathname, { state: updatedState });
            dispatch({ type: TCActionsTypes.SET_TC_FIELD_VALUES, payload: { ...basicDetails, ...response } });
          } else if (response == "TestingandCommission  Already Exists ") {
            setFailedDialogOpenForDocumentSerialNumberDuplicate(true);
          }
        } else {
          console.log("Error generating T&C number");
          setButtondisabled(false);
        }

      }
      return response;
    } catch (error) {
      console.error("Error saving Testing and Commission details:", error);
      setButtondisabled(false);
    }
  };

  const handleSave = async (status) => {
    const { id, isEditMode } = basicDetailsTC;

    const response = await handleCreateUpdate(isEditMode, id, status);
    return response;
  };

  const handleSavePage = () => {
    const isValid = validateForm();
    if (isValid) {
      const status = {
        Testcommissionstatus: 'Open',
        id: 1
      }
      const response = handleSave(status);
      if (response?.id && tcNo) {
        setSuccessDialogOpen(true)
      }
    } else {
      setIsFilledAllMandatoryField(true);
    }
  };

  const handleContinueClick = () => {
    const data = 'Others';
    dispatch({ type: TCActionsTypes.NEXT_PAGE, payload: { currentPage: data } });
  }

  const handleNextClick = async () => {
    const isValid = validateForm();
    if (isValid) {
      const getStatus = {
        Testcommissionstatus: (status === "authorized" || status === "completed" || status === "submitted" || status === "rejected") ? status : "In-Progress",// set status  In-progress
        id: (tcDetails?.statusid === 3 || tcDetails?.statusid === 4 || tcDetails?.statusid === 5 || tcDetails?.statusid === 6) ? tcDetails?.statusid : 2 // set the Status ID
      };
      const response = await handleSave(getStatus);
      if (response?.id) {
        let basicDetailsFieldValue;
        const basicDetailsWithID = { ...basicDetailsTC, isEditMode: true, id: response?.id };
        if (location.state.mode != 'create') {
          const responseField = await getTCListByID(location.state.rowData?.id, location.state?.service);
          basicDetailsFieldValue = await setBasicDetailsInfoInEditMode(responseField[0], location.state.rowData);
        }

        dispatch(setBasicDetailsFields(basicDetailsWithID));
        const updatedState = {
          ...location.state, // Keep existing state
          tcDetails: { ...location.state.tcDetails, ...response }, // Add or update keys
        };
        navigate(location.pathname, { state: updatedState });
        dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: response });
        const data = 'Others';
        dispatch({
          type: TCActionsTypes.NEXT_PAGE,
          payload: { currentPage: data, basicDetailsSavedData: basicDetailsTC }
        });
        if (location.state.mode != 'create') {
          navigate(location.pathname, {
            state: {
              ...location.state,
              basicDetails: { ...location.state.basicDetails, ...basicDetailsFieldValue },

              tcDetails: {
                ...location.state.tcDetails, riskstatus: basicDetailsTC?.criticality.label,
                userlocationid: basicDetailsTC?.location?.id
              },
              basicDetailsTc: basicDetailsWithID,
              mode: 'edit',
              id: response?.id

              // category: assetCategoryType?.category || "",
              // service: serviceType || "",
              // timestamp: createWorkOrderResponse?.timestamp || ""
            }
          });

        } else {
          navigate(location.pathname, {
            state: {
              ...location.state,
              // mode: 'edit',
              id: response?.id,
              basicDetails: { ...location.state.basicDetails, ...basicDetailsWithID },
              tcDetails: { ...location.state.tcDetails, vendorid: basicDetailsTC?.vendorname?.id },
              basicDetailsTc: { ...basicDetailsTC, id: response?.id },
              // category: assetCategoryType?.category || "",
              // service: serviceType || "",
              // timestamp: createWorkOrderResponse?.timestamp || ""
            }
          });
        }
      }
    } else {
      setIsFilledAllMandatoryField(true);
      console.log('Form validation failed. Please fill in all required fields.');
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleConfirmSubmit = () => {
    setDialogOpen(false);
    setSuccessDialogOpen(true);
  };

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false);
    navigate('/testingcommission');
  };
  //   const handleOnchange = (value, name) => {
  //   const formatNumericValue = (value, previousValue) => {
  //     if (value === "") return ""; // Allow empty input

  //     // Check if the value is a valid numeric input (includes decimal point)
  //     if (/^\d*\.?\d*$/.test(value)) {
  //       if (previousValue === "0.00") return value; // Replace `0.00` entirely with the user's input

  //       // If the input is purely zeros or starts with zeros and a decimal
  //       if (/^0+(\.0*)?$/.test(value)) {
  //         return "0"; // Keep it as "0" for clarity
  //       }

  //       // Remove leading zeros for integers
  //       if (!value.includes(".")) {
  //         return value.replace(/^0+/, "") || "0"; // Keep "0" if the result becomes empty
  //       }

  //       // Split the value into integer and decimal parts
  //       const [integerPart, decimalPart] = value.split(".");
  //       if (Number(integerPart) === 0) {
  //         return decimalPart ? `0.${decimalPart.replace(/^0+/, "").slice(0, 2)}` : "0."; // Retain "0." for clarity and limit to 2 decimal places
  //       }

  //       // Default valid case
  //       return `${integerPart.replace(/^0+/, "") || "0"}.${decimalPart.slice(0, 2)}`; // Remove leading zeros and limit to 2 decimal places
  //     }

  //     return previousValue; // Retain the previous valid value if input is invalid
  //   };

  // setCostInfoData((previous) => {
  //   let updatedValue = value;

  //   // Apply formatting for specific fields
  //   if (["purchaseprice"].includes(name)) {
  //     updatedValue = formatNumericValue(value, previous[name]);
  //   }

  //   const updatedData = {
  //     ...previous,
  //     [name]: updatedValue,
  //   };

  //   // Calculate totalWorkorderCost for specific fields
  //   const parsedValue = parseFloat(updatedData[name]) || 0;
  //   const parsedTotalSparePartCost = parseFloat(totalSparePartCost) || 0;

  //   if (name === "breakDownCost") {
  //     updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
  //   } else if (name === "ppmCostByPurchaseOrder") {
  //     updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
  //   } else if (name === "ppmCostByContract") {
  //     updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
  //   }

  //   return updatedData;
  // });
  // };



  return (
    <>
      <PageLoader open={isLoading} />
      <ComponentHeader
        mainHeader={"Basic Details"}
        subHeader={"Note: *Please enter the following fields and Submit to notify the Vendor: Service, Vendor Name, Type code, Work Group, Asset Description"}
        assetvalue={tcDetails?.testingcommissionno}
        requiredButton={!isDisableAllfileds}
        statusType={status}
      />
      <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }} >
        <form style={{ position: "relative" }} noValidate={true}>
          {isFilledAllMandatoryField && <Typography sx={{ color: "error.main" }}>Please Fill All Mandatory Fields(*)</Typography>}
          <Paper elevation={0} style={{ borderRadius: '5px', paddingBottom: '5px', margin: '-5px 2px 5px 2px', }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  id="service"
                  label="Service"
                  name="service"
                  disabled={isDisableAllfileds || basicDetailsTC?.isEditMode || isVendorLogin}
                  options={basicDetailsTCOptions?.serviceOptions}
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.service || ''}
                  isOptionEqualToValue={(option, value) => option.value === value?.value}
                  error={errorMessages?.service}
                  helperText={errors?.service ? errorMessages?.service : ''}
                  isMandatoryField={true}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  id="workgroup"
                  label="Work Group"
                  defaultValue="option1"
                  isMandatoryField={true}
                  disabled={isDisableAllfileds || basicDetailsTC?.isEditMode || isVendorLogin}
                  options={basicDetailsTCOptions?.workgroupOptions}
                  name="workgroup"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.workgroup || ''}
                  error={errors?.workgroup}
                  errorMessage={errorMessages?.workgroup}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextFieldWithSearch
                  label="Vendor Name"
                  isMandatoryField={true}
                  id="vendorname"
                  name="vendorname"
                  value={basicDetailsTC?.vendorname || ''}
                  disabled={isDisableAllfileds || basicDetailsTC?.isEditMode || isVendorLogin}
                  options={basicDetailsTCOptions?.vendorOptions}
                  onChange={handleFieldChange}
                  error={errorMessages.vendorname}
                  errorMessage={errorMessages.vendorname}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextFieldWithSearch
                  label="Type Code"
                  isMandatoryField={true}
                  id="typecode"
                  name="typecode"
                  value={basicDetailsTC?.typecode}
                  disabled={isDisableAllfileds || (basicDetailsTC?.isEditMode && statusId !== 1) || isVendorLogin}
                  options={basicDetailsTCOptions?.typecodeOptions}
                  onChange={handleFieldChange}
                  error={errors?.typecode}
                  errorMessage={errorMessages?.typecode}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Type Description"
                  id="typeDescription"
                  name="typeDescription"
                  placeholder=''
                  disabled={true}
                  value={basicDetailsTC?.typecode?.value || ''}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Asset Description"
                  id="assetdesc"
                  isMandatoryField={true}
                  name="assetdesc"
                  onChange={handleFieldChange}
                  disabled={isDisableAllfileds || (basicDetailsTC?.isEditMode && statusId !== 1) || isVendorLogin}
                  value={basicDetailsTC?.assetdesc || ''}
                  error={errors?.assetdesc}
                  errorMessage={errorMessages?.assetdesc}
                />
              </Grid>
              {!isVendorLogin && <Grid item xs={12}
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent: { xs: "end", md: "end" },
                  mt: -7,
                }} >
                {/* <Button variant='contained' onClick={handleSavePage} sx={{ margin: "10px" }}>Submit</Button> */}
                <AssetFooter
                  // onNextClick={handleNextClick}
                  handlSubmitClick={handleSavePage}
                  showSubmit={!isVendorLogin &&
                    !(tcDetails?.bemtestingcommissionstatusId || tcDetails?.femtestingcommissionstatusId || tcDetails?.isViewMode)}
                  showAuthorize={false}
                  enableSubmitButton={buttondisabled}
                  // showNext={false}
                  nextButtonTitle="Continue to Other details"
                  showCancel={false}
                  cancelButtonName="Cancel"
                  isVendorLogin={isVendorLogin}
                  handlCancelClick={() => {
                    if (!isVendorLogin) {
                      navigate('/testingcommission')
                    } else if (isVendorLogin) {
                      navigate('/VendorDashboard')
                    }
                  }}
                  showReject={false}
                  showConvertToAsset={false}
                  previous={false}
                  // continueNext={isDisableAllfileds}
                  // continueButtonTitle={"NEXT"}
                  // onContinueClick={handleContinueClick}
                  dataChanged={isDataChanged}
                />
              </Grid>}
            </Grid>
          </Paper>

          {/* //split bottom  */}

          <Paper elevation={0} style={{ marginTop: '30px', borderRadius: '5px', paddingTop: '25px', margin: '0 2px 20px' }}>

            <Grid container spacing={2}>

              {!isVendorLogin && <Grid item xs={12} md={tcDetails?.isViewMode ? 4 : 3.5} sm={6}>
                <CustomTextFieldWithSearch
                  label="Location Name"
                  id="location"
                  name="location"
                  value={basicDetailsTC?.location || ''} // 
                  options={basicDetailsTCOptions?.locationOptions} // Pass the department options
                  onChange={handleFieldChange}
                  disabled={isDisableAllfileds}
                  hideSearch={true}

                />
              </Grid>}
              {(!tcDetails?.isViewMode) && (!isVendorLogin) && (<Grid item xs={6} md={0.8} style={{ paddingLeft: "5px" }}>

                {!tcDetails?.isViewMode && (
                  <Grid sx={{ mt: 2.7 }} item>
                    <Button onClick={handleOpenModal} variant="contained" >
                      <SearchIcon />
                    </Button>
                  </Grid>
                )}

                <Dialog
                  open={isModalOpen}
                  onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                      return; // Prevent closing on backdrop click
                    }
                    handleCloseModal(); // Call the close function for other reasons
                  }}
                  //onClose={handleCloseModal}
                  aria-labelledby="asset-grid-dialog"
                  aria-describedby="grid-display-for-assets"
                  maxWidth="lg"
                  fullWidth
                ><DialogTitle
                  id="asset-grid-dialog"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1.5rem', // Adjust font size as desired
                    display: 'flex',
                    justifyContent: 'space-between', // Space out title and icon
                    alignItems: 'center',
                  }}
                >
                    Location Serach
                    <IconButton
                      aria-label="close"
                      variant="outlined"
                      onClick={handleCloseModal}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent
                    dividers
                    sx={{
                      overflowY: 'auto', // Enables scroll if content overflows
                      height: 'auto',    // Allows height to adjust based on content
                      maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                    }}
                  >
                    <CustomAgGrid
                      rows={basicDetailsTCOptions?.locationOptions}
                      columns={columns}
                      // loading={loadingAssets}
                      ref={gridApi}
                      setGridApi={setGridApi}
                    />
                    <Stack my={3} direction={"row"} justifyContent={"end"}>
                      <Button variant="outlined" onClick={handleCloseModal}>
                        Close
                      </Button>
                    </Stack>
                  </DialogContent>
                </Dialog>

              </Grid>)}

              {!isVendorLogin && <Grid item xs={6} md={7.5} sm={6}>
                <CustomTextField
                  label="User Department"
                  id="department"
                  name="department"
                  placeholder=''
                  disabled={true}
                  value={basicDetailsTC?.location?.userdepartment || basicDetails?.location?.userdepartment || ''}
                />
              </Grid>}

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Model"
                  id="model"
                  name="model"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.model || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Serial No."
                  id="serialno"
                  name="serialno"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.serialno || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>

              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Chasis No."
                  id="chassisno"
                  name="chassisno"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.chassisno || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>}

              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Registration No."
                  id="registerno"
                  name="registerno"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.registerno || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>}


              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Purchase Cost in RM."
                  id="purchaseprice"
                  name="purchaseprice"
                  onlyNumbers={true}
                  onChange={handleFieldChange}
                  value={
                    basicDetailsTC?.purchaseprice
                  }
                  disabled={isDisableAllfileds}
                  numbersLength={30}
                  placeholder="0.00"
                  allowDecimal={true}
                  textAlign="right"
                />

              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Purchase Order No."
                  id="purchaseorderno"
                  name="purchaseorderno"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.purchaseorderno || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>

              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Finance Asset No."
                  id="financeassetno"
                  name="financeassetno"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.financeassetno || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>}

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Manufacturer"
                  id="Manufacturer"
                  name="manufacturer"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.manufacturer || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>


              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomDatePicker
                  label="Warranty Start Date"
                  id="warrantystartdate"
                  name="warrantystartdate"
                  // dissablePastDate={true}
                  isStartDate={true}
                  onDateChange={handleFieldChange}
                  value={basicDetailsTC?.warrantystartdate || ''}
                  maxDate={basicDetailsTC?.warrantyexpirydate || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>}

              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  id="criticality"
                  label="Criticality"
                  name="criticality"
                  value={basicDetailsTC?.criticality || ''}
                  options={basicDetailsTCOptions?.criticalityOptions}
                  onChange={handleFieldChange}
                  disabled={isDisableAllfileds}
                />
              </Grid>

              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomDatePicker
                  label="Warranty End Date"
                  id="warrantyexpirydate"
                  name="warrantyexpirydate"
                  value={basicDetailsTC?.warrantyexpirydate || ''}
                  onDateChange={handleFieldChange}
                  minimumDate={basicDetailsTC?.warrantystartdate}
                  disabled={isDisableAllfileds}
                />
              </Grid>}

              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  id="warrenty"
                  label="Under Warranty"
                  name="isunderwarranty"
                  value={basicDetailsTC?.isunderwarranty ? 'Yes ' : 'No'}
                  disabled={true}
                />
              </Grid>}


              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Life Span (Estimated)"
                  id="lifespan"
                  name="lifespan"
                  onlyNumbers={true}
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.lifespan || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>
              {!isVendorLogin && <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="T&C Remarks"
                  id="remarks"
                  name="remarks"
                  onChange={handleFieldChange}
                  value={basicDetailsTC?.remarks || ''}
                  disabled={isDisableAllfileds}
                />
              </Grid>}
            </Grid>
          </Paper>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: { xs: "center", md: "end" },
              mt: -5,
            }}
          >

            <AssetFooter
              onNextClick={handleNextClick}
              handlSubmitClick={handleSavePage}
              enableSubmitButton={buttondisabled}
              // showSubmit={!isVendorLogin &&
              // !(tcDetails?.bemtestingcommissionstatusId || tcDetails?.femtestingcommissionstatusId)}
              showAuthorize={false}
              showNext={!isDisableAllfileds}
              nextButtonTitle="Continue to Other details"
              showCancel={true}
              cancelButtonName="Cancel"
              isVendorLogin={isVendorLogin}
              handlCancelClick={() => {
                if (!isVendorLogin) {
                  navigate('/testingcommission')
                } else if (isVendorLogin) {
                  navigate('/VendorDashboard')
                }
              }}
              showReject={false}
              showConvertToAsset={false}
              previous={false}
              continueNext={isDisableAllfileds}
              continueButtonTitle={"NEXT"}
              onContinueClick={handleContinueClick}
              dataChanged={isDataChanged}
            />
          </Box>
        </form>
      </Box>

      <CustomAlert
        open={dialogOpen}
        onClose={handleDialogClose}
        onConfirm={handleConfirmSubmit}
        content="Are you sure you want to save?"
        cancelBtn='Cancel'
        confirmBtn='Yes'
      />

      <CustomAlert
        open={failedDialogOpen}
        onClose={() => setFailedDialogOpen(false)}
        onConfirm={() => setFailedDialogOpen(false)}
        content="Can't able to save at that moment. Please try again later!"
        confirmBtn='OK'
      />
      <CustomAlert
        open={failedDialogOpenForDocumentSerialNumberDuplicate}
        onClose={() => setFailedDialogOpenForDocumentSerialNumberDuplicate(false)}
        onConfirm={() => setFailedDialogOpenForDocumentSerialNumberDuplicate(false)}
        content="T&C No. Already Exist. Please check Document serial number."
        confirmBtn='OK'
      />

      <CustomAlert
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
        onConfirm={handleSuccessDialogClose}
        content={`${tcNo} have been successfully shared to Vendor`}
        confirmBtn='OK'
      />

    </>
  );
};
export default BasicDetails;
